/**
 * A clue counts as "written" when it has clue text AND at least one non-blank
 * acceptable answer. Single source of truth for the "X of Y clues written"
 * counts in the toolbar, sidebar, and category panel.
 *
 * NOTE: this is stricter than the server's `hasContent` (functions/src/utils/
 * clueCompletion.js), which only checks `answers.length > 0`. A question with
 * `answers: [""]` is "written" server-side but not here — tracked in the editor
 * follow-ups issue.
 */
export const isClueWritten = (q) =>
  !!(
    q?.clue?.trim() &&
    Array.isArray(q?.answers) &&
    q.answers.some((a) => a?.trim())
  );
